﻿import React, {FC} from 'react';
import {SupplierActivitySummaryCardListItem} from "./SupplierActivitySummaryCardListItem";
import {SupplierActivitySummaryVo} from "../../../types/supplier/SupplierActivitySummaryVo";
import {withLoader} from "../../hocs/withLoader";
import {SupplierActivitySummaryCardListLoader} from "./SupplierActivitySummaryCardListLoader";

type SupplierActivitySummaryCardListProps = {
  activitySummaries?: SupplierActivitySummaryVo[];
  collapseByIndex: boolean[];
  onToggleCollapse: (index: number) => void;
}

/**
 * Component that takes a list of activitySummaries and conditionally renders them
 * @param activitySummaries list of summaries to display
 * @param collapseByIndex array of booleans describing whether items should be collapsed or not
 * @param onToggleCollapse function callback when an item is clicked to determine whether to expand/collapse
 * @constructor
 */
const SupplierActivitySummaryCardList: FC<SupplierActivitySummaryCardListProps> = ({ activitySummaries, collapseByIndex, onToggleCollapse }) => {
  return <>
    {
      !!(activitySummaries?.length) && (
        activitySummaries.map((activitySummary, index) => (
          <SupplierActivitySummaryCardListItem key={activitySummary.location + activitySummary.currentInventory}
                                               activitySummary={activitySummary}
                                               collapse={collapseByIndex[index]}
                                               onToggleCollapse={() => onToggleCollapse(index)}
          />
        )
      ))
    }
  </>
}

/**
 * Component that conditionally renders the base component or the loader depending upon its isLoading prop
 */
const SupplierActivitySummaryCardListWithLoader = withLoader(SupplierActivitySummaryCardList, SupplierActivitySummaryCardListLoader);

export { SupplierActivitySummaryCardListWithLoader };
